import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/jaisalmer.jpg";
import Newsletter from "../../shared/Newsletter";
import { Helmet } from "react-helmet";

const Jaisalmer = () => {
  return (
    <>
    <Helmet>
  <title>Explore Jaisalmer: The Golden City of Rajasthan's Forts & Enchanting Havelis</title>

  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />

  <meta name="description" content="Discover Jaisalmer, Rajasthan's 'Jewel of the Desert' and 'Golden City,' renowned for its majestic forts, captivating havelis, and centuries-old houses. Unveil Jaisalmer's iconic attractions like the formidable Jaisalmer Fort, exquisite havelis like Patwon-ki-Haveli and Salim-Singh-ki-Haveli, and the serene Gadsisar Lake. Journey through the Desert National Park's diverse landscapes, embark on thrilling camel safaris amidst golden dunes, and immerse yourself in Jaisalmer's vibrant festivals and renowned handicrafts. Experience the timeless charm of Jaisalmer, where history whispers from every corner." />

  <meta name="keywords" content="Jaisalmer, Rajasthan, Golden City, Jewel of the Desert, Jaisalmer Fort, Patwon-ki-Haveli, Salim-Singh-ki-Haveli, Gadsisar Lake, Desert National Park, camel safaris, wildlife, handicrafts, festivals, havelis, history, culture, golden dunes" />

  <meta name="author" content="The Rustic Paths" />

  <meta property="og:title" content="Explore Jaisalmer: The Golden City of Rajasthan's Forts & Enchanting Havelis" />
  <meta property="og:description" content="Discover Jaisalmer, Rajasthan's 'Jewel of the Desert' and 'Golden City,' renowned for its majestic forts... (trimmed for brevity)" />
  <meta property="og:image" content={tour1} />
</Helmet>

      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">
          Jaisalmer
        </h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Jaisalmer Fort</li>
                      <li>Jaisalmer Havelis</li>
                      <li>Desert National Park</li>
                      <li>Gadsisar Lake</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Jaisalmer
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    Jaisalmer, popularly referred as the "the Jewel of the
                    Desert," is one of the most fascinating cities of Rajasthan,
                    India. Also known as "the Golden City of India," Jaisalmer
                    is famous for its magnificent forts, bewitching palaces,
                    havelis (mansions) and centuries old houses.
                  </p>
                  <p>
                    Jaisalmer is also known for its exotic sand dunes and
                    electrifying camel safaris. Jaisalmer has a number of
                    exciting tourist attractions showcasing the royal splendor
                    of the bygone era.
                  </p>

                  <p>
                    The major tourist fascinations in Jaisalmer include the
                    Jaisalmer Fort, Patwon-ki-haveli, Nathmalji-ki-haveli,
                    Salim-Singh- ki-haveli, Tazia tower, Bar Bagh and the
                    beautiful Gadsisar Lake. Its exquisite handicrafts and
                    colorful festivals are other major tourist attractions.
                    Jaisalmer is also known for its exotic sand dunes, offering
                    exciting and unforgettable camel safaris. The vivid and
                    colorful festivals of Jaisalmer are other major attractions
                    for tourists visiting the city.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Jaisalmer Fort{" "}
                  </h2>

                  <p>
                    Jaisalmer Fort is one of the most intimidating forts in
                    Rajasthan, India built in the 12th century. Perched on
                    Trikuta hill, Jaisalmer Fort is a 250 ft tall and massive
                    fort surrounded by a 30 ft high sandstone wall with 99
                    bastions, offering a spectacular sight to visitors. A
                    spectacular Jain Temple is also situated in the fort.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Jaisalmer Havelis
                  </h2>
                  <p>
                    Built by the wealthy merchants, the havelis (mansions) of
                    Jaisalmer are illustrious for their exclusive cutwork,
                    yellow and red stone treatment and the bracket-shaped
                    decoration of peacocks. The ostentatioushavelis like the
                    Patwon-ki-Haveli, Salim-Singh-ki-Haveli and
                    Nathmaljikihaveli are major tourist attractions in
                    Jaisalmer.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Desert National Park
                  </h2>
                  <p>
                    An excellent ecosystem that covers a total area of about
                    3160 square km and was notified a National park in the year
                    1980. The National park is rich in diverse varieties of
                    fauna, which include Chinkara, Desert Hare, Blackbuck,
                    Desert Snake, fox and vultures.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Gadsisar Lake
                  </h2>
                  <p>
                    A rain water lake, located near "Tillon Ki Gate", adorned
                    with an arched gateway is a major tourist attraction in
                    Jaisalmer. Many small shrines and temples are festooned a11
                    around the lake. It is a water conservation tank made in the
                    15th Century AD. One can see a large number of birds, most
                    of which migrate from the Bharatpur Bird Sanctuary located
                    nearby. Today, it is an ideal picnic spot, famous for
                    boating.
                  </p>

                  
                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Jaisalmer;
